var AbstractWS = require("./AbstractWS");

/**
 * Web Service handler to retrieve and represent a list of services
 * at a location or Merchant
 *
 * @class ServiceTransactionStartWS
 */
var ServiceTransactionStartWS = function () {
  var self; // Convenience reference so the context of 'this' becomes clearer

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.appointmentId = ko.observable(null);
  self.method = ko.observable('POST');
  // Convenience name for debugging
  self.name = 'ServiceTransactionStartWS';
  self.queueId = ko.observable(null);
  self.phone = ko.observable(null);
  self.partySize = ko.observable(null);


	/**
	 * API Endpoint
	 *
	 * @method serviceURL
	 * @return {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/serviceTransaction/start';
  });


	/**
	 * Requests data from the API service
	 *
	 * @method doRequest
	 * @return none
	 */
  self.doRequest = function () {
    self.clearParams();

    self.addParam('queueId', self.queueId());
    self.addParam('phone', self.phone());
    self.addParam('appointmentId', self.appointmentId());

    if (self.partySize() != null) {
      self.addParam('partySize', self.partySize());
    }

    AbstractWS.prototype.doRequest.call(self);
  };


	/**
	 * Processes the return from the API service
	 *
	 * @method processData
	 * @param {XMLDocument} xmlData
	 * @return none
	 */
  self.processData = function (xmlData) {
    AbstractWS.prototype.processData.call(self, xmlData);

    // Once the session has been started change the status to STARTED_EARLY
    if (self.errorMessage() == null) {
      self.parent.updateAppointmentStatusWS.update(self.appointmentId(), 'SERVED_EARLY');
    }
  };

  return self;
};

ServiceTransactionStartWS.prototype = AbstractWS.prototype;
ServiceTransactionStartWS.prototype.constructor = ServiceTransactionStartWS;

module.exports = ServiceTransactionStartWS
